import { getReplaceValue, isReplacer, nodeNamesToPath, prepareConfig } from './util.common.js';
import 'lodash/isPlainObject';
import 'lodash/transform';

const transformDataUtils = {
    getReplaceValue,
    isReplacer,
    nodeNamesToPath,
    prepareConfig,
};

export { transformDataUtils };
